<template>
	<div class="dropdown form-group" :class="{ 'is-empty': empty, 'is-disabled': readonly }" :data-element="element.id"
		:title="readonly ? $t('app.common.readonly') : ''">
		<div class="d-flex justify-content-between align-items-center">
			<label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
				<span v-html="macro(label)"></span>
				<small v-if="required" class="required">*</small>
			</label>
			<div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
				<app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
			</div>
		</div>
		<select v-if="!printing && !custom" class="form-select" v-model="value" @change="select"
			:class="classes('input')" :data-label="label" :disabled="readonly" :readonly="readonly"
			:required="required">
			<option value="">{{ trans('buttons.select') }}</option>
			<optgroup v-for="g in groups" :label="g.name">
				<option v-for="i in rows(g)" :value="i.value">{{ i.label }}</option>
			</optgroup>
			<option v-if="allowcustom" value="pfp-other">{{ $t('app.common.other_type') }}</option>
		</select>
		<div v-if="!printing && custom" class="input-group">
			<input type="text" ref="custom" maxlength="128" class="form-control" v-model="other" @blur="update"
				:class="classes('input')" :data-label="label" :disabled="readonly" :readonly="readonly"
				:required="required">
			<button v-if="!readonly" type="button" class="input-group-text" :class="classes('input')" @click="clear">
				<app-icon value="close"></app-icon>
			</button>
		</div>
		<div v-if="printing" class="form-control border--element">{{ custom ? other : selected(value) }}</div>
		<div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }">
			<span v-if="!valid">{{ $t('validation.mandatory') }}</span>
		</div>
		<small class="form-text" :class="classes('description')">
			<span v-if="description" v-html="macro(description)"></span>&nbsp;
		</small>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		allowcustom() {
			return this.options('custom') == true
		},
		custom() {
			return this.allowcustom && this.value === 'pfp-other'
		},
		description() {
			return typeof this.definition.description == 'string' ? this.definition.description : null
		},
		empty() {
			return this.value == '' && this.other == ''
		},
		groups() {
			let s = this.options('structure');
			return s && s.groups ? s.groups : []
		},
		label() {
			return this.definition.title
		},
		printing() {
			return store.state.printing == true
		},
		readonly() {
			return store.getters.readonly(this.definition, !this.empty)
		},
		required() {
			return this.options('required') == true
		},
		valid() {
			return !(this.element && this.element.valid === false)
		},
		fieldVisibleOnlyInPreview() {
			return this.definition.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	data() {
		return { value: '', other: '' }
	},
	watch: {
		'element.value': {
			immediate: true,
			handler(value) {
				this.value = ''
				this.other = ''
				if (value != null && value != '' && typeof value == 'string' || typeof value == 'number') {
					value = value.toString()
					if (this.exists(value)) {
						this.value = value.trim()
					} else if (value.split("|").length == 2) {
					} else if (this.allowcustom) {
						this.value = 'pfp-other';
						this.other = value
					}
				}
			}
		}
	},
	methods: {
		classes(index) {
			return store.getters['classes'](index)
		},
		clear(event) {
			this.other = this.value = ''
		},
		exists(value) {
			return this.selected(value) != ''
		},
		macro(value) {
			return store.getters['macro'](value)
		},
		options(value) {
			return store.getters['options'](this.definition, value)
		},
		rows(group) {
			let items = []
			if (group && group.scope && group.scope == 'static') {
				items = group.items.map(i => {
					if (i.value && typeof i.value == 'string') {
						i.value = i.value.trim()
					}
					return i
				})
			}
			if (group && group.scope && group.scope != 'static' && group.items) {
				items = store.getters['dynamicItems'](group.items[0].value, group.items[0].label)
			}
			return items
		},
		select(event) {
			if (event.target.value === 'pfp-other') {
				this.value = 'pfp-other'
				this.other = ''
				this.$nextTick(() => {
					if (this.$refs.custom) this.$refs.custom.focus()
				})
			} else if (this.$validate(event) && event.target.value !== this.element.value) {
				store.commit('QUEUE', { id: this.element.id, group: this.element.group, value: this.value })
			}
		},
		selected(value) {
			let r = ''
			value = value && typeof value == 'string' ? value.trim() : value
			this.groups.forEach(g => {
				if (!r && this.rows(g).find(i => i.value == value)) {
					r = this.rows(g).find(i => i.value == value).label
				}
			})
			return r
		},
		update(event) {
			if (this.element.value === null && this.empty) {
				return
			}
			let v = event.target.value ? event.target.value.trim() : event.target.value
			if (!this.readonly && this.$validate(event) && (this.element.value == null || v !== this.element.value.trim())) {
				let gk = this.element.group + '|' + this.definition.group
				store.commit('QUEUE', { id: this.element.id, group: gk, value: this.other.trim() })
			}
		},
		trans(key) {
			let trans = store.getters.trans(key)
			return trans ? trans : this.$t('front.' + key)
		}
	}
}
</script>
